export const SISTANI_ASK_URL = 'https://www.sistani.org/english/send-question/';
